var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGameFiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1030_5623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 33.0001C32.4881 33.0031 33.4659 32.7988 34.3699 32.4001L44.718 27.8001C45.2484 27.5644 45.6992 27.18 46.0155 26.6932C46.3317 26.2065 46.5 25.6386 46.5 25.0581V9.4581C46.5 8.87764 46.3317 8.30964 46.0155 7.82295C45.6992 7.33624 45.2484 6.95175 44.718 6.7161L34.3699 2.11609C33.4667 1.71388 32.4888 1.50604 31.5 1.50604C30.5112 1.50604 29.5334 1.71388 28.6301 2.11609L18.282 6.7161C17.7528 6.95121 17.303 7.33446 16.9868 7.81959C16.6706 8.30472 16.5015 8.87101 16.5 9.45009V15.0001",
    fill: "url(#paint0_linear_1030_5623)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 33.0001C32.488 33.0031 33.4659 32.7988 34.3699 32.4001L44.718 27.8001C45.2484 27.5644 45.6992 27.18 46.0155 26.6932C46.3317 26.2065 46.5 25.6386 46.5 25.0581V9.4581C46.5 8.87764 46.3317 8.30964 46.0155 7.82295C45.6992 7.33624 45.2484 6.95175 44.718 6.7161L34.3699 2.11609C33.4666 1.71388 32.4888 1.50604 31.5 1.50604C30.5112 1.50604 29.5334 1.71388 28.6301 2.11609L18.282 6.7161C17.7528 6.95121 17.303 7.33446 16.9868 7.81959C16.6706 8.30472 16.5015 8.87101 16.5 9.45009V15.0001",
    stroke: "white",
    strokeOpacity: 0.11,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1030_5623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.63 45.89C14.5334 46.2923 15.5112 46.5002 16.5 46.5002C17.4888 46.5002 18.4666 46.2923 19.3699 45.89L29.718 41.2901C30.2484 41.0544 30.6991 40.67 31.0155 40.1832C31.3317 39.6965 31.5001 39.1284 31.5 38.5481V22.9481C31.5001 22.3676 31.3317 21.7995 31.0155 21.3129C30.6991 20.8262 30.2484 20.4417 29.718 20.2061L19.3699 15.606C18.4666 15.2039 17.4888 14.996 16.5 14.996C15.5112 14.996 14.5334 15.2039 13.63 15.606L3.28201 20.2001C2.75031 20.4363 2.29876 20.822 1.98237 21.3102C1.66597 21.7985 1.49838 22.3682 1.50001 22.95V38.55C1.49994 39.1305 1.66825 39.6986 1.98456 40.1852C2.30085 40.6719 2.75155 41.0564 3.28201 41.292L13.63 45.89Z",
    fill: "url(#paint1_linear_1030_5623)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.63 45.89C14.5334 46.2923 15.5112 46.5002 16.5 46.5002C17.4888 46.5002 18.4666 46.2923 19.3699 45.89L29.718 41.2901C30.2484 41.0544 30.6991 40.67 31.0155 40.1832C31.3317 39.6965 31.5001 39.1284 31.5 38.5481V22.9481C31.5001 22.3676 31.3317 21.7995 31.0155 21.3129C30.6991 20.8262 30.2484 20.4417 29.718 20.2061L19.3699 15.606C18.4666 15.2039 17.4888 14.996 16.5 14.996C15.5112 14.996 14.5334 15.2039 13.63 15.606L3.28201 20.2001C2.75031 20.4363 2.29876 20.822 1.98237 21.3102C1.66597 21.7985 1.49838 22.3682 1.50001 22.95V38.55C1.49994 39.1305 1.66825 39.6986 1.98456 40.1852C2.30085 40.6719 2.75155 41.0564 3.28201 41.292L13.63 45.89Z",
    stroke: "white",
    strokeOpacity: 0.11,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0498 7.71991L31.4999 13.4999L45.9499 7.71991",
    stroke: "white",
    strokeOpacity: 0.11,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20.2721C16.5986 20.2718 16.6962 20.291 16.7872 20.3286C16.8784 20.3661 16.9613 20.4213 17.0309 20.4911C17.1006 20.5608 17.1558 20.6436 17.1935 20.7347C17.2311 20.8257 17.2503 20.9234 17.25 21.0219",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 21.0219C15.7497 20.9234 15.7689 20.8257 15.8066 20.7347C15.8442 20.6436 15.8994 20.5608 15.9692 20.4911C16.0388 20.4213 16.1216 20.3661 16.2128 20.3286C16.3038 20.291 16.4015 20.2718 16.5 20.2721",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21.7719C16.3011 21.7719 16.1103 21.693 15.9696 21.5523C15.8291 21.4116 15.75 21.2209 15.75 21.0219",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 21.0219C17.25 21.2209 17.1709 21.4116 17.0304 21.5523C16.8897 21.693 16.6989 21.7719 16.5 21.7719",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9561 29.1379C26.0546 29.1376 26.1523 29.1568 26.2435 29.1945C26.3345 29.2321 26.4173 29.2873 26.4871 29.3569C26.5567 29.4267 26.6119 29.5095 26.6495 29.6005C26.6872 29.6917 26.7064 29.7894 26.7061 29.8879",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 29.8879C25.1998 29.7894 25.219 29.6917 25.2565 29.6005C25.2942 29.5095 25.3494 29.4267 25.4191 29.3569C25.4889 29.2873 25.5715 29.2321 25.6627 29.1945C25.7538 29.1568 25.8514 29.1376 25.95 29.1379",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9561 30.638C25.7572 30.638 25.5664 30.5589 25.4258 30.4182C25.2851 30.2777 25.2061 30.0869 25.2061 29.888",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7061 29.888C26.7061 30.0869 26.627 30.2777 26.4865 30.4182C26.3458 30.5589 26.155 30.638 25.9561 30.638",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 38.684C11.4489 38.684 11.6397 38.763 11.7803 38.9037C11.921 39.0443 12 39.2351 12 39.434",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 39.434C10.5 39.2351 10.579 39.0443 10.7197 38.9037C10.8603 38.763 11.0511 38.684 11.25 38.684",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 40.184C11.0511 40.184 10.8603 40.1049 10.7197 39.9644C10.579 39.8237 10.5 39.6329 10.5 39.434",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12 39.434C12 39.6329 11.921 39.8237 11.7803 39.9644C11.6397 40.1049 11.4489 40.184 11.25 40.184",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6 27.434C6.19891 27.434 6.38968 27.513 6.53032 27.6537C6.67098 27.7943 6.75 27.9851 6.75 28.184",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 28.184C5.25 27.9851 5.32902 27.7943 5.46968 27.6537C5.61032 27.513 5.80109 27.434 6 27.434",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6 28.934C5.80109 28.934 5.61032 28.8549 5.46968 28.7144C5.32902 28.5737 5.25 28.3829 5.25 28.184",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 28.184C6.75 28.3829 6.67098 28.5737 6.53032 28.7144C6.38968 28.8549 6.19891 28.934 6 28.934",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36206 32.692C8.45953 32.7066 8.55315 32.7403 8.63757 32.7912C8.72199 32.842 8.79556 32.9091 8.85406 32.9884C8.91258 33.0678 8.95488 33.1578 8.97856 33.2535C9.00223 33.3492 9.00682 33.4485 8.99206 33.546",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50806 33.3219C7.53816 33.1254 7.64492 32.9487 7.80497 32.8306C7.96502 32.7126 8.16533 32.6626 8.36205 32.6919",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13795 34.1761C7.94134 34.146 7.76467 34.0392 7.64661 33.8791C7.52853 33.7191 7.47868 33.5189 7.50795 33.3221",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 33.546C8.98535 33.6435 8.95162 33.7371 8.90075 33.8216C8.8499 33.906 8.7829 33.9795 8.70358 34.038C8.62427 34.0965 8.5342 34.1388 8.43853 34.1625C8.34286 34.1862 8.24345 34.1909 8.146 34.176",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.728 36.858C22.8266 36.8577 22.9242 36.8771 23.0154 36.9146C23.1065 36.9522 23.1893 37.0074 23.259 37.0772C23.3286 37.1468 23.3838 37.2296 23.4215 37.3208C23.4591 37.4118 23.4783 37.5095 23.478 37.608",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.978 37.6001C21.9777 37.5014 21.9969 37.4037 22.0346 37.3127C22.0722 37.2216 22.1274 37.1388 22.1972 37.0691C22.2668 36.9993 22.3496 36.9441 22.4408 36.9066C22.5318 36.869 22.6295 36.8498 22.728 36.8501",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.728 38.358C22.5291 38.358 22.3383 38.279 22.1978 38.1384C22.0571 37.9977 21.978 37.8069 21.978 37.608",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.478 37.6001C23.478 37.799 23.399 37.9896 23.2584 38.1303C23.1177 38.271 22.9269 38.3501 22.728 38.3501",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 6.45593C31.6989 6.45593 31.8897 6.53494 32.0304 6.67559C32.1709 6.81625 32.25 7.00702 32.25 7.20593",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 7.20007C30.75 7.00116 30.8291 6.81039 30.9696 6.66975C31.1103 6.52909 31.3011 6.45007 31.5 6.45007",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 7.95593C31.3011 7.95593 31.1103 7.87691 30.9696 7.73626C30.8291 7.5956 30.75 7.40483 30.75 7.20593",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 7.20007C32.25 7.39899 32.1709 7.58974 32.0304 7.7304C31.8897 7.87105 31.6989 7.95007 31.5 7.95007",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 15.0861C41.4489 15.0861 41.6397 15.1652 41.7804 15.3057C41.9209 15.4464 42 15.6372 42 15.8361",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 15.8361C40.5 15.6372 40.5791 15.4464 40.7196 15.3057C40.8603 15.1652 41.0511 15.0861 41.25 15.0861",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 16.5861C41.0511 16.5861 40.8603 16.5071 40.7196 16.3664C40.5791 16.2258 40.5 16.035 40.5 15.8361",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M42 15.8361C42 16.035 41.9209 16.2258 41.7804 16.3664C41.6397 16.5071 41.4489 16.5861 41.25 16.5861",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 22.5861C41.4489 22.5861 41.6397 22.6652 41.7804 22.8057C41.9209 22.9464 42 23.1372 42 23.3361",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 23.3361C40.5 23.1372 40.5791 22.9464 40.7196 22.8057C40.8603 22.6652 41.0511 22.5861 41.25 22.5861",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 24.0861C41.0511 24.0861 40.8603 24.0071 40.7196 23.8664C40.5791 23.7258 40.5 23.535 40.5 23.3361",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23.3361C42 23.535 41.9209 23.7258 41.7804 23.8664C41.6397 24.0071 41.4489 24.0861 41.25 24.0861",
    stroke: "#6741D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 27V46.5",
    stroke: "white",
    strokeOpacity: 0.11,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05005 21.2199L16.5001 26.9998L30.95 21.2199",
    stroke: "white",
    strokeOpacity: 0.11,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1030_5623",
    x: 13.5,
    y: 1.50604,
    width: 33,
    height: 32.4941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.87451 0 0 0 0 0.905882 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1030_5623"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1030_5623",
    x: -1.5,
    y: 14.996,
    width: 33,
    height: 32.5042,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.87451 0 0 0 0 0.905882 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1030_5623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1030_5623",
    x1: 34.2391,
    y1: 2.26349,
    x2: 25.165,
    y2: 30.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1030_5623",
    x1: 19.2391,
    y1: 15.7537,
    x2: 10.1597,
    y2: 44.4974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameFiLogo);
export default __webpack_public_path__ + "static/media/gameFiLogo.2831151045afadfb846d101b97d66448.svg";
export { ForwardRef as ReactComponent };